import { StudentSupportOrbit } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentSupportOrbit(studentNo: string) {
    try {
        const response = await portalApi.get<StudentSupportOrbit>(`/students/${studentNo}/support-orbit`);
        return response.data
    } catch (error) {
        console.error("Error fetching student support orbit:", error);
        throw error;
    }
}
